import React from 'react';
import Select from 'react-select';
import { StateManagerProps } from 'react-select/dist/declarations/src/useStateManager';

const MultiValueContainer = ({ selectProps, data }) => {
  const label = data.label;
  const allSelected = selectProps.value;
  const index = allSelected?.findIndex(selected => selected.label === label);
  const isLastSelected = index === allSelected.length - 1;
  const labelSuffix = isLastSelected ? ` (${allSelected.length})` : ', ';
  const val = `${label}${labelSuffix}`;
  return <>{val}</>;
};
export default function AppFormSelect({ value, options, ...props }: StateManagerProps) {
  const ref = React.useRef<any>();
  const selectedValue = React.useMemo(() => {
    if (typeof value === 'object') {
      return value;
    }
    return options?.find((x: any) => x?.value === value);
  }, [value, options]);
  const onMenuOpen = () => {
    try {
      ref.current.controlRef.childNodes[0].scrollLeft = 0;
    } catch (error) {}
  };
  return (
    <Select
      autoFocus={false}
      ref={ref}
      components={{
        MultiValueContainer: MultiValueContainer,
      }}
      value={selectedValue}
      options={options}
      {...props}
      onMenuOpen={onMenuOpen}
    />
  );
}
